import React from "react";
import CompatioLoader from "../../../Common/components/CompatioLoader";

const LoadingSuccessErrorAlert = ({ loading }) => {
  return (
    <>
      {loading.status === "Saving" && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "Loading" && (
        // <div className="aalert alert-primary bg-white small p-2" role="alert">
        //   <span className="fas fa-circle-notch fa-spin" />
        //   &nbsp;
        //   <strong>{loading.message}</strong>
        // </div>
        <CompatioLoader width="120px" height="120px" />
      )}
      {loading.status === "Error" && (
        <div className="alert alert-danger bg-white small p-2" role="alert">
          <span className="fas fa-exclamation-triangle" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "Success" && loading.message !== undefined && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="far fa-check-circle" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
    </>
  );
};
export default LoadingSuccessErrorAlert;
